import React from 'react';
import { Box } from '@mui/material';
import AutocompleteCqlFecha from './buttons_cqlFecha.js';
import AutocompleteLayersGeoserver from './buttons_layersAI.js';
import AutocompleteIssueTimestamp from './buttons-issueTime.js';
import AutocompleteIssueTimestampHours from './buttons-issueTime_hours.js';

/**
 * Container component for performance view control buttons
 * @param {Object} props - Component props
 * @returns {JSX.Element} ButtonsContainer component
 */
const ButtonsContainer = ({
  cqlFecha,
  selectedModel,
  cqlFechaMax,
  cqlFechaMin,
  issueTimeOptions,
  issueTime,
  onDateChange,
  onModelClick,
  onDateSelect,
  onTimeSelect,
  onBackdropOpen,
  onBackdropClose,
  setIssueTimeOptions,
  showAllButtons = true
}) => {
  return (
    <div className="buttons-container">
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
        <Box sx={{ marginX: 2, mb: 1.5, mt: 1 }}>
          <AutocompleteCqlFecha 
            cqlFecha={cqlFecha} 
            handleDateChange={onDateChange} 
          />
        </Box>
        
        <Box sx={{ marginX: 2, mb: 1.5, mt: 1 }}>
          <AutocompleteLayersGeoserver 
            selectedModel={selectedModel} 
            handleModelClick={onModelClick} 
          />
        </Box>
        
        {showAllButtons && (
          <>
            <Box sx={{ marginX: 2, mb: 1.5, mt: 1 }}>
              <AutocompleteIssueTimestamp 
                handleDateSelect={onDateSelect} 
                cqlFechaMax={cqlFechaMax} 
                cqlFechaMin={cqlFechaMin} 
                handleBackdropOpen={onBackdropOpen} 
                handleBackdropClose={onBackdropClose} 
                setIssueTimeOptions={setIssueTimeOptions}
              />
            </Box>
            
            <Box sx={{ marginX: 2, mb: 1.5, mt: 1 }}>
              <AutocompleteIssueTimestampHours 
                issueTimeOptions={issueTimeOptions} 
                issueTime={issueTime} 
                handleTimeSelect={onTimeSelect} 
              />
            </Box>
          </>
        )}
      </Box>
    </div>
  );
};

export default ButtonsContainer;
